import { useMutation } from 'react-query';
import { httpService } from '../../../services/http.service';
import { BASE_URL } from '../../../constants/endpoints';
import { MfaType } from '../../../generic-components/MFA/types';

interface IProps {
  customerId: string;
  answer: string;
  mfaType: MfaType;
  authorizedUserExternalId: string;
}

export const useValidateMfaCode = () =>
  useMutation('useValidateMfaCode', async ({ customerId, answer, mfaType, authorizedUserExternalId }: IProps) => {
    const res = await httpService.post(`${BASE_URL}/api/v1/user/${customerId}/authorized/user/validateMfa`, {
      answer,
      mfaType,
      authorizedUserExternalId,
    });
    return res.data;
  });
